export default "__VITE_ASSET__b375ccde__"